/// <reference path="../../ng-services/chat.service.ts"/>

export class ConversationPreviousMessageLoaderComponent {
    onClick?: () => any;
    isLoading!: boolean;
}

angular.module('tradersyard').component('tyConversationPreviousMessageLoader', {
    template: `
<div class="conversation_previous_message_loader__spinner" ng-if="$ctrl.isLoading">
    <ty-loading-spinner/>
</div>
<div ng-if="!$ctrl.isLoading" class="conversation_previous_message_loader">
    <a href="#" ng-if="$ctrl.hasMore" ng-click="$ctrl.onClick(); $event.preventDefault()"
       class="conversation_previous_message_loader__load_more_btn">Load older messages</a>
    <span ng-if="!$ctrl.hasMore" class="conversation_previous_message_loader__end_reached">No more messages</span>
</div>
    `,
    controller: ConversationPreviousMessageLoaderComponent,
    bindings: {
        isLoading: '<',
        hasMore: '<',
        onClick: '&',
    },
});
